// extracted by mini-css-extract-plugin
module.exports = {"optionTextContainer":"FilterBookType__optionTextContainer","valueTextContainer":"FilterBookType__valueTextContainer"};